"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CompanyPrism;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_webview_1 = __importDefault(require("react-native-webview"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_i18next_1 = require("react-i18next");
const cancelable_promise_1 = require("cancelable-promise");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const UserContext_1 = require("../contexts/UserContext");
const AdminContext_1 = require("../contexts/AdminContext");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const SingleSignOn_1 = require("../shared/SingleSignOn");
const ElevatePermissions_1 = __importDefault(require("../ElevatePermissions"));
const CompanyMenu_1 = require("../partials/CompanyMenu");
const ActionMenuButton_1 = __importDefault(require("../components/ActionMenuButton"));
const Employees_1 = __importDefault(require("../api/Employees"));
const MyProfile_1 = __importDefault(require("../api/MyProfile"));
const OverlayContext_1 = require("../contexts/OverlayContext");
const CompanyEmployeeMenu = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const adminContext = react_1.default.useContext(AdminContext_1.AdminContext);
    const { width } = (0, ResponsiveContext_1.useResponsiveContext)();
    const detailsPromise = react_1.default.useRef(null);
    const [details, setDetails] = react_1.default.useState(null);
    const refreshDetails = () => {
        detailsPromise.current?.cancel();
        detailsPromise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => Employees_1.default.getManageDetails(token, employeeId))).then((data) => {
            setDetails(data);
        }).catch((error) => {
            console.error(error);
        });
    };
    const [riskAndCompliance] = react_1.default.useState(userContext.client?.features?.find((feature) => feature.name === 'wc-risk'));
    const riskAndComplianceDisabled = riskAndCompliance == null || !riskAndCompliance?.isEnabled;
    const permissionsPromise = react_1.default.useRef(null);
    const [showPermissions, setShowPermissions] = react_1.default.useState(false);
    const [showWorkersComp] = react_1.default.useState(!riskAndComplianceDisabled);
    let employeeId = props.route?.params?.employeeId;
    let menu = adminContext.employeeMenu;
    let previous = null;
    let current = null;
    let next = null;
    if (employeeId && menu && Array.isArray(menu)) {
        let index = adminContext.employeeMenu.findIndex((e) => e.id == employeeId);
        if (index > 0)
            previous = adminContext.employeeMenu[index - 1];
        current = adminContext.employeeMenu[index];
        if (index < adminContext.employeeMenu.length - 1)
            next = adminContext.employeeMenu[index + 1];
    }
    const prismMobileSize = width < 768; // Breakpoint used by Prism portal.
    const timeAndAttendance = userContext.client?.features?.find((feature) => feature.name === 'time-and-attendance');
    react_1.default.useEffect(() => {
        const canManagePermissions = userContext.permissions?.includes(ElevatePermissions_1.default.ManagePermissions);
        if (!canManagePermissions) {
            setShowPermissions(false);
            return;
        }
        setShowPermissions(false);
        permissionsPromise.current?.cancel();
        permissionsPromise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => MyProfile_1.default.getPermissions(token, employeeId)))
            .then((data) => {
            var availablePermissions = Object.getOwnPropertyNames(ElevatePermissions_1.default).filter(x => {
                if (data?.role?.includes('A'))
                    return x != 'CoIAccess';
                if (riskAndComplianceDisabled)
                    return false;
                else
                    return x == 'CoIAccess';
            });
            setShowPermissions(availablePermissions.length > 0);
        })
            .catch((error) => {
            console.error(error);
        });
        return () => {
            permissionsPromise.current?.cancel();
        };
    }, [
        employeeId,
        riskAndComplianceDisabled,
        userContext.permissions
    ]);
    react_1.default.useEffect(() => {
        refreshDetails();
        let handlers = [
            'event.employeeTerminate',
            'event.employeeRehire',
            'event.lifeEventUpdate',
            'event.employeePhotoUpload'
        ].map(event => react_native_1.DeviceEventEmitter.addListener(event, () => {
            props.navigation?.replace?.('CompanyEmployeeDetail', { employeeId });
        }));
        return () => handlers.forEach(h => h.remove());
    }, []);
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
            // @ts-ignore
            userSelect: 'none',
            backgroundColor: THEME.CardBackground,
            borderBottomColor: THEME.CardBorder,
            borderBottomWidth: 1,
            height: 48,
            paddingLeft: (prismMobileSize ? 8 : 12),
            paddingRight: (prismMobileSize ? 8 : 26),
            flexDirection: 'row',
            alignItems: 'center',
            gap: (prismMobileSize ? 12 : 32),
        }, children: [!prismMobileSize &&
                (0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onPress: () => props.navigation.navigate('CompanyEmployees'), style: ({ pressed }) => ({
                        backgroundColor: (pressed ? THEME.CardBorder + 33 : THEME.CardBackground),
                        paddingHorizontal: 8,
                        paddingVertical: 6,
                        flexDirection: 'row', gap: 4, alignItems: 'center',
                        borderRadius: 4
                    }), children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { size: 14, icon: Theme_1.ICONS.Solid.ChevronLeft, style: { color: THEME.Primary, marginTop: -1 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: 16, fontWeight: '400' }, children: t('common:screenTitles.employees') })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginRight: -12 } }), (next || previous) &&
                (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 8 }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { disabled: !previous, onPress: () => {
                                if (previous) {
                                    props.navigation.push('CompanyEmployeeDetail', { employeeId: previous?.id });
                                }
                            }, style: ({ pressed }) => ({
                                backgroundColor: (pressed ? THEME.CardBorder + 33 : THEME.CardBackground),
                                borderRadius: 4,
                                paddingHorizontal: 8,
                                paddingVertical: (prismMobileSize ? 10 : 6),
                                flexDirection: 'row', gap: 6, alignItems: 'center',
                                opacity: (previous ? 1 : 0)
                            }), children: [(previous || prismMobileSize) &&
                                    (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { size: 14, icon: Theme_1.ICONS.Solid.ArrowLeft, style: { color: THEME.Primary, marginTop: -1 } }), !prismMobileSize &&
                                    (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: (prismMobileSize ? 14 : 16), fontWeight: '300' }, children: previous ? previous.fullName : current?.fullName })] }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { size: 16, icon: Theme_1.ICONS.Regular.Users, style: { color: THEME.Primary, marginTop: -1 } }), (0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { disabled: !next, onPress: () => {
                                if (next) {
                                    props.navigation.push('CompanyEmployeeDetail', { employeeId: next?.id });
                                }
                            }, style: ({ pressed }) => ({
                                backgroundColor: (pressed ? THEME.CardBorder + 33 : THEME.CardBackground),
                                borderRadius: 4,
                                paddingHorizontal: 8,
                                paddingVertical: (prismMobileSize ? 10 : 6),
                                flexDirection: 'row', gap: 6, alignItems: 'center',
                                opacity: (next ? 1 : 0)
                            }), children: [!prismMobileSize &&
                                    (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: (prismMobileSize ? 14 : 16), fontWeight: '300' }, children: next ? next.fullName : current?.fullName }), (next || prismMobileSize) &&
                                    (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { size: 14, icon: Theme_1.ICONS.Solid.ArrowRight, style: { color: THEME.Primary, marginTop: -1 } })] })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { children: (0, jsx_runtime_1.jsx)(ActionMenuButton_1.default, { label: t('common:labels.manage'), buttonType: "outline", actionsList: [
                        {
                            label: t('company:labels.viewOrgChart'),
                            icon: Theme_1.ICONS.Solid.ChartDiagram,
                            iconSize: 18,
                            iconColor: THEME.Primary,
                            onPress: () => props.navigation.navigate('OrgChart', { employeeId })
                        },
                        {
                            label: t('company:labels.viewBenefits'),
                            icon: Theme_1.ICONS.Solid.BriefcaseMedical,
                            iconSize: 18,
                            iconColor: THEME.Primary,
                            onPress: () => props.navigation.navigate('CompanyEmployeeBenefitDetails', { employeeId, status: current?.statusClass ?? 'A' })
                        },
                        (details?.nextepMedical) &&
                            {
                                label: details?.lifeEventInProgress ? t('myBenefits:text.lifeEventInProgress') : t('myBenefits:text.reportLifeEvent'),
                                icon: Theme_1.ICONS.Solid.FileMedical,
                                iconSize: 18,
                                iconColor: THEME.Primary,
                                disabled: details?.lifeEventInProgress,
                                onPress: () => props.navigation.navigate('AddLifeEvent', { employeeId })
                            },
                        showWorkersComp &&
                            {
                                label: t('company:labels.fileWcClaim'),
                                icon: Theme_1.ICONS.Solid.FileCertificate,
                                iconSize: 18,
                                iconColor: THEME.Primary,
                                onPress: () => props.navigation.navigate('WorkersCompClaimSubmit', { employeeId })
                            },
                        showPermissions &&
                            {
                                label: t('profile:text.permissions'),
                                icon: Theme_1.ICONS.Solid.Key,
                                iconSize: 18,
                                iconColor: THEME.Primary,
                                onPress: () => props.navigation.navigate('PermissionsEdit', { id: employeeId })
                            },
                        (!!userContext.isAdmin &&
                            !userContext.isImpersonated &&
                            !!timeAndAttendance?.isEnabled &&
                            (timeAndAttendance?.vendor?.toLowerCase() === 'kronos')) &&
                            {
                                label: t('profile:text.Timesheet'),
                                icon: Theme_1.ICONS.Solid.Clock,
                                iconSize: 18,
                                iconColor: THEME.Primary,
                                external: true,
                                onPress: () => SingleSignOn_1.SingleSignOn.Perform({
                                    navigation: props.navigation,
                                    title: t('profile:text.Timesheet'),
                                    client: userContext?.client?.id,
                                    provider: 'kronos',
                                    query: {
                                        targetType: 'timesheet',
                                        targetId: employeeId,
                                        ...(react_native_1.Platform.OS == 'web' && { redirect: 'json' })
                                    }
                                })
                            },
                        ((details?.statusClass == 'A' || details?.statusClass == 'L') &&
                            userContext.permissions?.includes(ElevatePermissions_1.default.Terminate)) && {
                            label: t('employees:labels.terminate'),
                            icon: Theme_1.ICONS.Solid.PersonCircleMinus,
                            iconSize: 18,
                            iconColor: THEME.Primary,
                            onPress: () => props.navigation.navigate('TerminateEmployee', { employeeId })
                        },
                        ((details?.statusClass == 'T') &&
                            userContext.permissions?.includes(ElevatePermissions_1.default.Hire)) && {
                            label: t('employees:labels.rehire'),
                            icon: Theme_1.ICONS.Solid.PersonCirclePlus,
                            iconSize: 18,
                            iconColor: THEME.Primary,
                            onPress: () => props.navigation.navigate('RehireEmployee', { employeeId })
                        },
                        {
                            label: t('company:labels.uploadPhoto'),
                            icon: Theme_1.ICONS.Solid.SquareUser,
                            iconSize: 18,
                            iconColor: THEME.Primary,
                            onPress: () => props.navigation.navigate('CompanyEmployeePhoto', { employeeId })
                        }
                    ] }) })] }));
};
function CompanyPrism(props) {
    const THEME = (0, ThemeContext_1.useTheme)();
    const adminContext = react_1.default.useContext(AdminContext_1.AdminContext);
    const { hasFloatings } = (0, OverlayContext_1.useOverlay)();
    const { width } = (0, ResponsiveContext_1.useResponsiveContext)();
    const prismMobileSize = width < 768; // Breakpoint used by Prism portal.
    const focus = react_1.default.useRef(null);
    const viewref = react_1.default.useRef(null);
    const messageRef = react_1.default.useRef(null);
    const [loading, setLoading] = react_1.default.useState(true);
    const [frameUrl, setFrameUrl] = react_1.default.useState('');
    const navigate = () => {
        let url = '';
        let allowed = false;
        let state = props.navigation.getState();
        let count = state?.routes?.length;
        let route = state?.routes?.[count - 1]?.name;
        if (!adminContext?.data)
            return;
        if (route in CompanyMenu_1.Routes) {
            url = CompanyMenu_1.Routes[route].prismUrl(props.route?.params);
            allowed = CompanyMenu_1.Routes[route].checkAccess(adminContext);
        }
        if (allowed && url) {
            url = adminContext?.navigate(url);
            if (url)
                setFrameUrl(url);
        }
        else {
            setTimeout(() => props.navigation.navigate('Company'), 250);
        }
    };
    react_1.default.useEffect(() => {
        focus.current = props.navigation.addListener('focus', () => navigate());
        return () => {
            focus.current?.();
            if (react_native_1.Platform.OS == 'web') {
                if (messageRef.current) {
                    window.removeEventListener('message', messageRef.current);
                    messageRef.current = null;
                }
            }
        };
    }, []);
    react_1.default.useEffect(() => {
        navigate();
    }, [adminContext?.initialized]);
    const frameRef = react_1.default.useCallback(() => {
        if (react_native_1.Platform.OS == 'web') {
            if (messageRef.current) {
                window.removeEventListener('message', messageRef.current);
                messageRef.current = null;
            }
            messageRef.current = (event) => {
                if (event?.origin == adminContext?.prismBaseUrl &&
                    event?.data?.includes?.('"type":"load"')) {
                    try {
                        let data = JSON.parse(event?.data);
                        if (data.url?.endsWith?.('/#/ess/manager/employees')) {
                            setFrameUrl('about:blank');
                            props.navigation.navigate?.('CompanyEmployees');
                        }
                    }
                    catch { }
                }
            };
            window.addEventListener('message', messageRef.current);
        }
    }, [adminContext?.prismBaseUrl]);
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { ref: viewref, style: { flex: 1, backgroundColor: '#ffffff' }, children: [props.route?.name == 'CompanyEmployeeDetail' &&
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { height: prismMobileSize ? 48 : 12 } }), react_native_1.Platform.OS == 'web'
                &&
                    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [hasFloatings && (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    zIndex: 10,
                                } }), (0, jsx_runtime_1.jsx)("iframe", { ref: frameRef, src: frameUrl, onLoad: () => setTimeout(() => setLoading(false), 600), style: { flex: 1, border: 'none' } }, frameUrl)] })
                ||
                    (0, jsx_runtime_1.jsx)(react_native_webview_1.default, { source: { uri: frameUrl }, startInLoadingState: true, allowFileAccess: true, geolocationEnabled: false, hideKeyboardAccessoryView: true, setSupportMultipleWindows: false, overScrollMode: "never", style: { flex: 1 }, onMessage: () => null, onLoadEnd: () => setTimeout(() => setLoading(false), 600), onNavigationStateChange: (event) => {
                            if (event.url?.endsWith?.('/#/ess/manager/employees')) {
                                setFrameUrl('');
                                props.navigation.navigate?.('CompanyEmployees');
                            }
                        } }, frameUrl), props.route?.name == 'CompanyEmployeeDetail' &&
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { position: 'absolute', top: 0, left: 0, right: 0 }, children: (0, jsx_runtime_1.jsx)(CompanyEmployeeMenu, { navigation: props.navigation, route: props.route }) }), (!adminContext?.initialized || loading) &&
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                        backgroundColor: THEME.CardBackground,
                        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                        flexDirection: 'row', alignItems: 'center', justifyContent: 'center'
                    }, children: (0, jsx_runtime_1.jsx)(react_native_1.ActivityIndicator, { color: THEME.Primary, size: react_native_1.Platform.OS == 'web' ? 64 : 'large' }) })] }));
}
